import { useTranslation } from 'react-i18next';
import { Download } from '@linktivity/link-icons';
import { INBOX_ENABLED } from '@link/share/constants';
import {
  SettingsIcon,
  BookingIcon,
  PaymentIcon,
  BulkOrderIcon,
  ContractIcon,
  SupplierIcon,
  OrderIcon,
  NoteIcon
} from '@link/share/icons';
import { SidebarMenu, bottomItems } from '@link/share/layouts';
import { auth, supplier } from '@link/supplier/stores';

const isProd = import.meta.env.VITE_APP_SUPPLIER_ENV === 'production';

const Sidebar = () => {
  const { t } = useTranslation();
  const isAtLeastEditor = auth.isLinkAdmin || auth.isAdmin || auth.isEditor;
  const isAdminOrLinkAdmin = auth.isAdmin || auth.isLinkAdmin;
  const menuItems = [
    ...(auth.isLinkAdmin
      ? [
          {
            label: t('layouts.sidebar.contractsList'),
            name: 'contractsList',
            to: '/contracts',
            Icon: ContractIcon
          }
        ]
      : []),
    {
      label: t('layouts.sidebar.suppliers'),
      Icon: SupplierIcon,
      name: 'suppliers',
      children: [
        ...(isAdminOrLinkAdmin
          ? [
              {
                label: t('layouts.sidebar.suppliersDetail'),
                to: '/supplier/detail'
              }
            ]
          : []),
        {
          label: t('layouts.sidebar.suppliersAccount'),
          to: '/supplier/accounts'
        }
      ]
    },
    {
      label: t('layouts.sidebar.activitiesManagement'),
      name: 'activities',
      Icon: OrderIcon,
      children: [
        {
          label: t('layouts.sidebar.activities'),
          to: '/activities',
          end: true
        },
        ...(auth.isViewer // viewer角色不显示在库
          ? []
          : [
              {
                label: t('layouts.sidebar.allotmentSettings'),
                to: `/allotment-settings?supplier=${supplier.selectCustomerId}`,
                end: true
              }
            ]),
        ...(auth.isLinkAdmin
          ? [
              {
                label: t('layouts.sidebar.backendSettings'),
                to: '/backend-settings',
                end: true
              }
            ]
          : [])
      ]
    },
    {
      label: t('layouts.sidebar.booking'),
      Icon: BookingIcon,
      name: 'book',
      children: [
        {
          label: t('share.views.bookingList.title'),
          to: '/book/booking'
        },
        ...(isAtLeastEditor
          ? [
              {
                label: t('views.bookingTodos.title'),
                to: '/book/todos'
              }
            ]
          : [])
      ]
    },
    ...(isAtLeastEditor && !isProd
      ? [
          {
            label: t('layouts.sidebar.bulkOrder'),
            Icon: BulkOrderIcon,
            name: 'bulkOrder',
            children: [
              {
                label: t('share.views.bookingList.title'),
                to: '/bulk-order/list'
              }
            ]
          }
        ]
      : []),
    ...(isAtLeastEditor
      ? [
          {
            label: t('layouts.sidebar.finance'),
            Icon: PaymentIcon,
            name: 'finance',
            children: [
              {
                label: t('views.financeHistory.title'),
                to: '/finance/history'
              },
              ...(auth.isEditor
                ? []
                : [
                    {
                      label: t('views.financeTransactions.title'),
                      to: '/finance/transactions'
                    }
                  ]),
              {
                label: t('share.views.discrepancyList.title'),
                to: '/finance/discrepancies'
              }
            ]
          }
        ]
      : []),
    ...(INBOX_ENABLED
      ? [
          {
            label: t('layouts.sidebar.notifications'),
            name: 'notifications',
            Icon: NoteIcon,
            children: [
              {
                label: t('share.views.notificationInbox.title'),
                to: '/notifications/inbox'
              }
            ]
          }
        ]
      : []),
    // データ出力：本番环境暂不开放
    ...(isAtLeastEditor && !isProd
      ? [
          {
            label: t('layouts.sidebar.dataExport'),
            name: 'dataExport',
            to: '/data-export',
            Icon: Download
          }
        ]
      : []),
    ...(auth.isPasswordLogin
      ? [
          {
            label: t('layouts.sidebar.settings'),
            name: 'settings',
            Icon: SettingsIcon,
            children: [
              {
                label: t('layouts.sidebar.changePassword'),
                to: '/change-password'
              }
            ]
          }
        ]
      : [])
  ];
  const extendedBottomItems = [
    {
      label: t('share.common.manual'),
      to: 'https://sites.google.com/linktivity.co.jp/gds-neo/%E3%83%9B%E3%83%BC%E3%83%A0'
    },
    ...bottomItems
  ];

  return (
    <SidebarMenu menuItems={menuItems} bottomItems={extendedBottomItems} />
  );
};

export default Sidebar;
